export default {
  roofTypes: {},
  roofInfo: {},
  roofIntegrated: "",
};
